<template>
    <v-dialog v-model="show" persistent max-width="600px">
        <v-card>
            <v-card-title>
                <span class="headline">Creare director</span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row>
                        <errors v-if="errors.length" :errors="errors"></errors>
                        <v-col md="12">
                            <v-text-field
                                label="Denumire director*"
                                ref="folderName"
                                v-model="newFolderName"
                                @keyup.enter="createFolder" required
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">
                    Renuntare
                </v-btn>
                <v-btn color="blue darken-1" text @click="createFolder">
                    Creare
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import axios from "axios";
    import CreateFolderModal from "../../../../packages/media-manager/js/components/subcomponents/CreateFolderModal";
    import Errors from '../Components/Errors';

    export default {
        extends: CreateFolderModal,
        components: {
            Errors
        }
    };
</script>
